
<app-mwe-table [columns]="columns" [data]="specifications" [title]="'Specifications'" [showAddButton]="hasAddPermission" [showSearch]="true" 
(selectedAction)="selectedAction($event)" (searchTerm)="onSearchKeyword($event)" [initialSearchValue]="searchKeyword" [showPagination]="showPagination"
[totalEntries]="totalEntries"></app-mwe-table>





  
